import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { BowIcon } from './icons/NailIcons';
const links = [{
  href: '#servicios',
  label: 'Servicios'
}, {
  href: '#sobre-mi',
  label: 'Sobre mí'
}, {
  href: '#trabajos',
  label: 'Trabajos'
}, {
  href: '#opiniones',
  label: 'Opiniones'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,border-color] duration-200 ease-smooth ${scrolled ? 'border-b border-blush-200 bg-cream/90 shadow-soft backdrop-blur-md' : 'border-b border-transparent bg-transparent'}`} data-id="element-170" data-mp="36as9uudldkml">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-5 py-4 sm:px-8" data-id="element-171" data-mp="2wldw5nefh198">
        <a href="#inicio" className="flex items-center gap-2.5 text-ink" data-id="element-172" data-mp="2rl880h7d9wvw">
          <BowIcon className="h-7 w-7 text-fucsia-deep" data-id="element-173" data-mp="2mmop6po2l17r" />
          <span className="font-serif text-2xl font-semibold leading-none tracking-tight" data-id="element-174" data-mp="2mn6ro41bsbo4">
            Cami Nails
          </span>
        </a>

        <nav aria-label="Navegación principal" className="hidden items-center gap-8 lg:flex" data-id="element-175" data-mp="3fbcbmokk1wmw">
          {links.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-ink-soft transition-colors duration-150 ease-smooth hover:text-fucsia-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-fucsia-deep" data-id="element-176" data-mp="3abzjboawzxcx">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-177" data-mp="3tav7oj03dhiu">
          <a href="#reservar" className="hidden rounded-full bg-fucsia-deep px-6 py-3 text-sm font-semibold text-white shadow-soft transition-[transform,background-color] duration-150 ease-smooth hover:-translate-y-0.5 hover:bg-fucsia-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fucsia-deep sm:inline-flex" data-id="element-178" data-mp="3t90ob94gxxgv">
            Agendar turno
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="menu-movil" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-blush-200 bg-white/80 text-ink transition-colors duration-150 ease-smooth hover:bg-blush-100 lg:hidden" data-id="element-179" data-mp="18mtx3nagu5ot">
            {open ? <XIcon className="h-5 w-5" data-id="element-180" data-mp="2t0u7k7tahmdu" /> : <MenuIcon className="h-5 w-5" data-id="element-181" data-mp="2y1royi6h6cea" />}
          </button>
        </div>
      </div>

      {open && <div id="menu-movil" className="border-t border-blush-200 bg-cream/95 backdrop-blur-md lg:hidden" data-id="element-182" data-mp="me4ywjlzobmp">
          <nav aria-label="Navegación móvil" className="mx-auto grid max-w-7xl gap-1 px-5 py-4 sm:px-8" data-id="element-183" data-mp="hgwhwmckudn1">
            {links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="rounded-2xl px-3 py-3 text-base font-medium text-ink transition-colors duration-150 ease-smooth hover:bg-blush-100" data-id="element-184" data-mp="rdrbcqtztnug">
                {link.label}
              </a>)}
            <a href="#reservar" onClick={() => setOpen(false)} className="mt-1 rounded-full bg-fucsia-deep px-6 py-3 text-center text-base font-semibold text-white" data-id="element-185" data-mp="1f20tnirzztgu">
              Agendar turno
            </a>
          </nav>
        </div>}
    </header>;
}